<template>
    <div>
      <canvas ref="canvasRef"></canvas>
    </div>
  </template>
  
  <script setup>
  import { onMounted, ref } from 'vue';
  
  // 定义画布引用
  const canvasRef = ref(null);
  
  onMounted(() => {
    const canvas = canvasRef.value;
    const ctx = canvas.getContext('2d');
  
    // 设置画布大小
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
  
    const fontSize = 20;
    // 调整列间距，减少列数，让字符不那么密集
    const columnSpacing = 2;
    const columns = Math.floor(canvas.width / (fontSize * columnSpacing));
    const drops = [];
    // 计算每帧下落的像素数，约为 5px/秒
    const frameRate = 60; // 浏览器通常的刷新频率
    const targetSpeedPerSecond = 5;
    const speed = targetSpeedPerSecond / frameRate;
  
    // 初始化每列的下落位置
    for (let x = 0; x < columns; x++) {
      drops[x] = Math.floor(Math.random() * canvas.height / fontSize);
    }
  
    // 生成随机字符的函数
    const randomCharacter = () => {
      const charCodes = [
        ...Array.from({ length: 10 }, (_, i) => 48 + i), // 数字 0 - 9
        ...Array.from({ length: 26 }, (_, i) => 65 + i), // 大写字母 A - Z
        ...Array.from({ length: 26 }, (_, i) => 97 + i)  // 小写字母 a - z
      ];
      return String.fromCharCode(charCodes[Math.floor(Math.random() * charCodes.length)]);
    };
  
    // 绘制数字雨的函数
    const draw = () => {
      // 清空整个画布
      ctx.clearRect(0, 0, canvas.width, canvas.height);
  
      ctx.fillStyle = 'rgba(255,255,255,0.5)';
      ctx.font = `${fontSize}px monospace`;
  
      for (let i = 0; i < drops.length; i++) {
        const text = randomCharacter();
        // 根据列间距计算绘制位置
        ctx.fillText(text, i * fontSize * columnSpacing, drops[i] * fontSize);
  
        // 如果字符超出画布底部，将其重置到顶部
        if (drops[i] * fontSize > canvas.height) {
          drops[i] = -Math.floor(Math.random() * 20);
        } else {
          // 根据计算出的速度更新下落位置
          drops[i] += speed;
        }
      }
  
      // 循环调用 draw 函数，实现动画效果
      requestAnimationFrame(draw);
    };
  
    // 开始绘制数字雨
    draw();
  });
  </script>
  
  <style scoped>
  canvas {
    display: block;
  }
  </style>